export function findScrollBoundary(element: HTMLElement | null): HTMLElement | null {
  let current = element?.parentElement ?? null;

  while (current && current !== document.body) {
    const { overflowY } = window.getComputedStyle(current);

    if (overflowY === 'auto' || overflowY === 'scroll') {
      return current;
    }

    current = current.parentElement;
  }

  return null;
}
